module.exports = __webpack_public_path__ + "assets/img/lClass11.c60bd965.png";